import type { Member, Team } from "../types/team";

export function shuffle<T>(items: T[]): T[] {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

/**
 * 6 LINK + 5 Mahindra → 4 mixed pairs (1 LINK + 1 Mahindra)
 * and 1 trio (2 LINK + 1 Mahindra).
 */
export function makeTeams(linkNames: string[], mahindraNames: string[]): Team[] {
  const link: Member[] = shuffle(linkNames).map((name) => ({ name, school: "link" }));
  const mahindra: Member[] = shuffle(mahindraNames).map((name) => ({ name, school: "mahindra" }));

  const groups: Member[][] = [];
  for (let i = 0; i < 4; i++) {
    groups.push([link[i], mahindra[i]]);
  }
  groups.push([link[4], link[5], mahindra[4]]);

  return shuffle(groups).map((members, index) => ({
    id: index + 1,
    members: shuffle(members),
  }));
}

export function findDuplicates(names: string[]): Set<string> {
  const seen = new Set<string>();
  const dupes = new Set<string>();
  names.forEach((raw) => {
    const key = raw.trim().toLowerCase();
    if (!key) return;
    if (seen.has(key)) dupes.add(key);
    seen.add(key);
  });
  return dupes;
}

export function teamsToText(teams: Team[]): string {
  return teams
    .map((team) => {
      const label = team.members.length === 3 ? `Team ${team.id} (trio)` : `Team ${team.id}`;
      const names = team.members
        .map((m) => `${m.name} (${m.school === "link" ? "LINK" : "Mahindra"})`)
        .join(", ");
      return `${label}: ${names}`;
    })
    .join("\n");
}
